var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatFormattingi = function SvgChatFormattingi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M6.257 15.971a.433.433 0 0 1-.227-.557L9.036 8.23a.441.441 0 0 1 .777 0l3.006 7.184a.41.41 0 0 1-.238.539.4.4 0 0 1-.158.039.4.4 0 0 1-.369-.25l-.9-2.137H7.705l-.9 2.137a.44.44 0 0 1-.4.256.5.5 0 0 1-.148-.027m1.8-3.213h2.742L9.434 9.477zm8.7 2.816V15.5a2.2 2.2 0 0 1-1.377.492 2.215 2.215 0 0 1-2.215-2.219 2.217 2.217 0 0 1 2.215-2.215 2.27 2.27 0 0 1 1.377.492v-.068a.427.427 0 0 1 .416-.424.43.43 0 0 1 .422.424v3.592a.426.426 0 0 1-.422.418.42.42 0 0 1-.414-.418zm-2.754-1.8a1.384 1.384 0 0 0 1.377 1.377 1.384 1.384 0 0 0 1.377-1.377 1.385 1.385 0 0 0-1.377-1.375 1.385 1.385 0 0 0-1.375 1.374z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatFormattingi);
export default ForwardRef;